import { render, staticRenderFns } from "./FormQuarentineRules.vue?vue&type=template&id=7e80e052"
import script from "./FormQuarentineRules.vue?vue&type=script&lang=js"
export * from "./FormQuarentineRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports